import { useEffect, useMemo, useState } from "react";
import { Select } from "antd";
import { ChartFilterBar, LineChartCard } from "../../../components/Charts";
import type { FilterDefinition, FilterValues } from "../../../types/chartFilters";
import type { FilterOnChange } from "../../../components/Charts/ChartFilterBar";
import { makeYearRangeFilter, P1_SISTEMA_OPTIONS } from "../common/sharedFilterDefs";
import { useP1Data, type P1FilterValues } from "./useP1ChartData";
import CompareButton from "../common/CompareButton";

const DEFAULT_FILTERS: P1FilterValues = {
  yearRange: undefined,
  sistema:   "CAT",
  ambit:     "",
};

const P1ChartSection = () => {
  const [filters, setFilters] = useState<P1FilterValues>(DEFAULT_FILTERS);
  const { chart1Data, chart1Lines, chart2Data, chart2Lines, availableAmbits, loading, error } =
    useP1Data(filters);

  useEffect(() => {
    if (availableAmbits.length > 0 && !filters.ambit) {
      setFilters((prev) => ({ ...prev, ambit: availableAmbits[0] }));
    }
  }, [availableAmbits, filters.ambit]);

  const ambitOptions = useMemo(
    () => availableAmbits.map((a) => ({ value: a, label: a })),
    [availableAmbits]
  );

  const yearRangeFilters: FilterDefinition[] = useMemo(
    () => [makeYearRangeFilter(2015, 2022)],
    []
  );

  const handleFilterChange: FilterOnChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }) as P1FilterValues);
  };

  return (
    <>
      <ChartFilterBar
        filters={yearRangeFilters}
        values={filters as unknown as FilterValues}
        onChange={handleFilterChange}
        disabled={loading}
      />
      <LineChartCard
        title="Percentatge de matriculacions per àmbit"
        data={chart1Data}
        xKey="curs_academic"
        lines={chart1Lines}
        yLabel="Percentatge (%)"
        loading={loading}
        error={error}
        headerExtra={
          <Select
            value={filters.sistema}
            options={P1_SISTEMA_OPTIONS}
            onChange={(v) => setFilters((prev) => ({ ...prev, sistema: v }))}
            style={{ width: 160 }}
            disabled={loading}
          />
        }
      />
      <LineChartCard
        title="Comparativa entre sistemes per àmbit"
        data={chart2Data}
        xKey="curs_academic"
        lines={chart2Lines}
        yLabel="Percentatge (%)"
        loading={loading}
        error={error}
        headerExtra={
          <Select
            value={filters.ambit || undefined}
            options={ambitOptions}
            placeholder="Àmbit"
            onChange={(v) => setFilters((prev) => ({ ...prev, ambit: v }))}
            style={{ width: 280 }}
            disabled={loading}
          />
        }
      />
      <CompareButton />
    </>
  );
};

export default P1ChartSection;
